import { Stack } from '@mui/material';
import { SessionSkeletonProps } from '../Skeleton.types';
import { SkeletonText } from './SkeletonText';
import { SkeletonCircle } from './SkeletonCircle';

export const SessionSkeleton = ({ sx }: SessionSkeletonProps) => {
    return (
        <Stack direction="row" spacing={2} alignItems="center" sx={sx}>
            <SkeletonText width={120} height={16} />
            <SkeletonCircle size={32} />
            <SkeletonText width={208} height={16} />
            <SkeletonCircle size={32} />
            <SkeletonText width="100%" height={16} sx={{ flex: 1 }} />
            <SkeletonText width={96} height={16} />
            <SkeletonText width={96} height={16} />
        </Stack>
    );
};
